// @flow
import translations from "./index";

export default (tag: string, lang: string = "en-us"): string =>
  translations[lang][tag] || tag;
